import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'napa-calendar-icon',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './calendar-icon.component.html',
  styleUrl: './calendar-icon.component.scss',
})
export class CalendarIconComponent {}
